import gql from 'graphql-tag'

export const QUERY_GET_ORDER = gql`
  query getOrder($id: String!) {
    orders(where: { transaction_id: { _eq: $id } }) {
      customer_details
      discounts_cache
      dropoff_notes
      delivery_charge
      fulfillment_date
      fulfillment_time_range
      fulfillment_type
      gift_wrap_message
      gift_wrap_price
      recipient_details
      status
      store {
        id
        slug
        email
        address {
          contact_num
          city
          flat_number
          line_2
          line_1
          zip
          geom
        }
        name
      }
      order_items {
        id
        order_id
        quantity
        product_variant_id
        amount
        variant_vat
        variant_price
        applied_modifiers {
          id
          amount
          quantity
          modifier_id
          modifier {
            id
            name
            restrictions
          }
          modifier_group_id
          modifier_group {
            id
            name
          }
        }
        is_valid
        product_variant {
          options
          restrictions
          name
          product {
            name
          }
        }
      }
      order_notes
      total
      additional_store_fee
      additional_store_fee_cache
      metadata
    }
  }
`
